(function($) {
    'use strict';

    var templatename = {

        init: function() {
            // call below defined function on init
            this.functionName();
        },

        functionName : function () {
            // custom js goes here
        },
    };

    templatename.init();
       
    // header-navbar

jQuery(document).ready(function (jQuery) {

    jQuery('.navbar').on('click', '.navbar-toggle-btn', function (e) {
        e.preventDefault();
        if (!jQuery(this).hasClass("nav-open")) {
            jQuery('#navbar').removeClass('active');
            jQuery('body').removeClass('menu-active');
            jQuery(this).removeClass('nav-close').addClass('nav-open');
            //         jQuery('header').removeClass('nav-close').addClass('nav-open');

        } else {
            jQuery('#navbar').addClass('active');
            jQuery('body').addClass('menu-active');
            jQuery(this).removeClass('nav-open').addClass('nav-close');
        }
    });
});

    // for the mob menu
    jQuery(".navbar-nav .submenu-opener").on('click', function (e) {
        e.preventDefault();

        if (!jQuery(this).hasClass('closed')) {
            jQuery(this).addClass('closed');
            jQuery(this).next('ul.dropdown-menu').css('display', 'block');
        }
        else {
            jQuery(this).removeClass('closed');
            jQuery(this).next('ul.dropdown-menu').css('display', 'none');
        }
    });

})(jQuery);